/**
 * @generated SignedSource<<52ac7c48f47421701509c9b091f334f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OwnerApiSettings_info$data = {
  readonly apiToken: {
    readonly maskedToken: string;
  } | null;
  readonly platform: string;
  readonly uid: string;
  readonly " $fragmentSpreads": FragmentRefs<"OwnerScopedTokenDialog_ownerInfo">;
  readonly " $fragmentType": "OwnerApiSettings_info";
};
export type OwnerApiSettings_info$key = {
  readonly " $data"?: OwnerApiSettings_info$data;
  readonly " $fragmentSpreads": FragmentRefs<"OwnerApiSettings_info">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OwnerApiSettings_info",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platform",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ApiAccessToken",
      "kind": "LinkedField",
      "name": "apiToken",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maskedToken",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OwnerScopedTokenDialog_ownerInfo"
    }
  ],
  "type": "OwnerInfo",
  "abstractKey": null
};

(node as any).hash = "c14fba13173ace7a7f7e3daf232bbacf";

export default node;
